import {
  Create,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
  useRedirect,
} from "react-admin";

const FormTypeCreate = () => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();

  // Allow create OR module wildcard OR global wildcard
  if (
    !(
      permissions.includes("forms.create") ||
      permissions.includes("forms.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Create
      title="Create Feedback Type"
      mutationOptions={{
        onSuccess: () => {
          notify("Form Type created successfully", { type: "success" });
          redirect("list", "form-types"); // ✅ redirect to /form-types
        },
        onError: (error) => {
          notify(error.message || "Error creating form type", {
            type: "error",
          });
        },
      }}
    >
      <SimpleForm>
        <TextInput source="name" label="Form-Type" required />
      </SimpleForm>
    </Create>
  );
};

export default FormTypeCreate;